import { Component, ViewChild, OnInit, Input, ViewChildren,ElementRef, Output,EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CornerstoneDirective } from './cornerstone.directive';
import { ThumbnailDirective } from './thumbnail.directive';
import * as cornerstone from 'cornerstone-core';
import * as cornerstoneTools from 'cornerstone-tools';
import * as cornerstoneWebImageLoader from 'cornerstone-web-image-loader';
import * as dicomParser from 'dicom-parser';
import { HttpClient } from '@angular/common/http';
import { DicomUploadService } from '../../dicom-upload.service';
import { environment } from '../../../environments/environment';


@Component({
  selector: 'dicom-viewer',
  templateUrl: './dicom-viewer.component.html',
  styleUrls: ['./dicom-viewer.component.css']
})
export class DICOMViewerComponent implements OnInit {
  @Input() public enableViewerTools = true; // Set to true to enable tools by default
  @Input() public enablePlayTools = true; // Set to true to enable play/stop tools
  @Input() public downloadImagesURL = '';
  
  @Input() public maxImagesToLoad = 20;
  @Input() selectedImage: any;
  public loadedImages: any[] = [];
  @Input() images: any[] = [];
  @Output() metadataRequested = new EventEmitter<string>();

  public seriesList: any[] = [];
  public currentSeriesIndex = 0;
  public currentSeries: any = {};
  public imageCount = 0;
  public crosshairModeEnabled = false;
  public stackScrollWheelEnabled: boolean = false;
  public viewport: any = null;
  public showMetadata = false;
  public metadata: any = {};
  public groupedMetadata: {[key: string]: any[]} = {};
  public metadataLoading = false;
  public isCompareMode: boolean = false;
  public compareLeftIndex: number = -1;
  public compareRightIndex: number = -1;
  public compareLeftImage: any = null;
  public compareRightImage: any = null;
  public imagesWithMetadata: any[] = [];
  

  @ViewChild(CornerstoneDirective, { static: true }) viewPort: CornerstoneDirective;
  @ViewChildren(ThumbnailDirective) thumbnails: ThumbnailDirective[];
  @ViewChild('viewerElement', { static: false }) viewerElement: ElementRef;
  @ViewChild('regularImagesContainer', { static: false }) regularImagesContainer: ElementRef;

  private imageIdList: string[] = [];
  private element: any;
  @ViewChild('videoPlayer') videoPlayer!: ElementRef<HTMLVideoElement>;
  isVideo = false;
  videoUrl: string | null = null;
  activeView: '2d' | '3d' = '2d';
  errorMessage = '';
  public currentImageIndex = 0;
  public totalImages = 0;
  public activeTools: {[key: string]: boolean} = {};
  public stackScrollManuallyEnabled: boolean = false;
  @Input() public metadataPayload: any = null; 
  @Output() dataEvent = new EventEmitter<any>();
  showInfoData:boolean=false;
toolMetadata = [
  { name: 'Flip Vertical', useCase: 'Flip the image vertically for better anatomical orientation.', icon: '<i class="fas fa-arrows-alt-v"></i>' },
  { name: 'Flip Horizontal', useCase: 'Flip the image horizontally to match clinical view.', icon: '<i class="fas fa-arrows-alt-h"></i>' },
  { name: 'Rotate', useCase: 'Rotate the image for proper alignment.', icon: '<i class="fas fa-redo"></i>' },
  { name: 'Eraser', useCase: 'Erase unwanted annotations or drawings.', icon: '<i class="fas fa-eraser"></i>' },
  { name: 'Windowing', useCase: 'Adjust image contrast and brightness using window width and level.', icon: '<i class="fas fa-sliders-h"></i>' },
  { name: 'Zoom/Pan', useCase: 'Zoom into and move around the image for better inspection.', icon: '<i class="fas fa-search-plus"></i>' },
  { name: 'Pan', useCase: 'Move the image within the viewport.', icon: '<i class="fas fa-arrows-alt"></i>' },
  { name: 'Length', useCase: 'Measure linear distances between two points.', icon: '<i class="fas fa-ruler"></i>' },
  { name: 'Angle', useCase: 'Measure angles between intersecting lines.', icon: '<i class="fas fa-angle-double-right"></i>' },
  { name: 'Probe', useCase: 'Inspect pixel values at specific points.', icon: '<i class="fas fa-crosshairs"></i>' },
  { name: 'Elliptical ROI', useCase: 'Draw elliptical regions of interest for analysis.', icon: '<i class="fas fa-circle"></i>' },
  { name: 'Rectangle ROI', useCase: 'Draw rectangular regions of interest for analysis.', icon: '<i class="fas fa-square"></i>' },
  { name: 'Freehand ROI', useCase: 'Draw custom regions of interest for analysis.', icon: '<i class="fas fa-pencil-alt"></i>' },
  { name: 'Arrow Annotate', useCase: 'Point to specific features or abnormalities.', icon: '<i class="fas fa-arrow-right"></i>' },
  { name: 'Text Marker', useCase: 'Add textual annotations to the image.', icon: '<i class="fas fa-font"></i>' },
  { name: 'Scale Overlay', useCase: 'Display scale for accurate measurement reference.', icon: '<i class="fas fa-ruler-horizontal"></i>' },
  { name: 'Cobb Angle', useCase: 'Measure spinal curvature for scoliosis assessment.', icon: '<i class="fas fa-angle-left"></i>' },
  { name: 'Magnify', useCase: 'Zoom into specific regions for detailed inspection.', icon: '<i class="fas fa-search-plus"></i>' },
  { name: 'Invert', useCase: 'Invert image colors for enhanced visibility.', icon: '<i class="fas fa-adjust"></i>' },
  { name: 'Reset', useCase: 'Reset all transformations and annotations.', icon: '<i class="fas fa-undo"></i>' },
  { name: 'Previous Image', useCase: 'Navigate to the previous image in the stack.', icon: '<i class="fas fa-chevron-left"></i>' },
  { name: 'Next Image', useCase: 'Navigate to the next image in the stack.', icon: '<i class="fas fa-chevron-right"></i>' },
  { name: 'Delete Current Image', useCase: 'Remove the currently displayed image.', icon: '<i class="fas fa-trash"></i>' },
  { name: 'Stack Scroll (Mouse Wheel)', useCase: 'Scroll through image slices using mouse wheel.', icon: '<i class="fas fa-mouse"></i>' },
  { name: 'Compare Images', useCase: 'View multiple images side-by-side for comparison.', icon: '<i class="fas fa-columns"></i>' },
  { name: 'Download', useCase: 'Download the current image or image stack.', icon: '<i class="fas fa-download"></i>' },
  { name: 'View Metadata', useCase: 'Display metadata information for the current image.', icon: '<i class="fas fa-info-circle"></i>' }
];

  
  localApiURL= environment.pythonUrl;
  private targetImageCount = 0;

  constructor(private http: HttpClient,private dicomUploadService: DicomUploadService) { }

  public get hidePreviousImage(): any { 
    return { color: (this.viewPort.currentIndex < 1) ? 'black' : 'white' }; 
  }

  public get hideNextImage(): any { 
    return { color: (this.viewPort.currentIndex >= (this.imageCount - 1)) ? 'black' : 'white' }; 
  }
  

  public get moreImagestoLoad(): string {
    if (this.loadedImages.length < this.imageIdList.length && !this.loadingImages) {
      const imagesToLoad = (this.maxImagesToLoad <= 0) 
        ? (this.imageIdList.length - this.loadedImages.length) 
        : Math.min(this.maxImagesToLoad, this.imageIdList.length - this.loadedImages.length);
      return imagesToLoad.toString();
    } else return '';
  }

  public loadingImages = false;
  public get showProgress(): any { 
    return { display: (this.loadingImages) ? 'inline-block' : 'none' }; 
  }


public showSingleImage(image: any) {
  this.viewPort.resetImageCache();
  
  // Find the image in loadedImages
  const foundImage = this.loadedImages.find(img => img.imageId === image.imageId);
  
  if (foundImage) {
    this.viewPort.addImageData(foundImage);
    this.currentImageIndex = this.loadedImages.indexOf(foundImage);
  } else {
    // console.error('Image not found in loaded images');
  }
}



  ngOnInit() {
  this.element = this.viewPort.element;
  this.configureCornerstone();
  
  // Load images automatically if they're provided via Input
  if (this.images && this.images.length > 0) {
    this.loadStudyImages(this.images);
  }
}

public hasMetadataSupport(): boolean {
  return true;
}
public setMetadata(metadata: any) {
  this.metadata = metadata;
  this.groupMetadata(); // Group the metadata for display
}

public toggleMetadata() {
  this.showMetadata = !this.showMetadata;
  if (this.showMetadata && Object.keys(this.metadata).length === 0) {
    this.fetchMetadata();
  } else if (this.showMetadata) {
    // Refresh metadata when toggling on (in case image changed)
    this.fetchMetadata();
  }
}

public getCurrentImagePosition(): string {
  const currentImage = this.getCurrentDisplayedImage();
  if (!currentImage) return 'Unknown';
  
  const index = this.loadedImages.findIndex(img => img.imageId === currentImage.imageId);
  return index !== -1 ? `${index + 1} of ${this.totalImages}` : 'Unknown';
}

public getCurrentDisplayedImage(): any {
  if (this.crosshairModeEnabled && this.element) {
    try {
      const viewportState = cornerstone.getViewport(this.element);
      const stackState = cornerstoneTools.getToolState(this.element, 'stack');
      
      if (stackState && stackState.data && stackState.data.length > 0) {
        const currentImageId = stackState.data[0].imageIds[viewportState.imageIdIndex];
        return this.loadedImages.find(img => img.imageId === currentImageId);
      }
    } catch (error) {
      // console.warn('Error getting current image from crosshair mode:', error);
    }
  }
  
  // Fallback to currentImageIndex
  return this.loadedImages[this.currentImageIndex];
}


private fetchMetadata() {
  if (!this.hasMetadataSupport()) {
    this.showMetadata = false;
    return;
  }
  
  // Get the currently displayed image - this is crucial for crosshair mode
  let currentImage: any;
  
  if (this.crosshairModeEnabled && this.viewPort) {
    // In crosshair mode, get the image from the viewport's current state
    const viewportState = cornerstone.getViewport(this.element);
    const stackState = cornerstoneTools.getToolState(this.element, 'stack');
    
    if (stackState && stackState.data && stackState.data.length > 0) {
      const currentImageId = stackState.data[0].imageIds[viewportState.imageIdIndex];
      currentImage = this.loadedImages.find(img => img.imageId === currentImageId);
    }
  }
  
  // Fallback to currentImageIndex if crosshair mode detection fails
  if (!currentImage && this.loadedImages.length > 0 && this.currentImageIndex >= 0) {
    currentImage = this.loadedImages[this.currentImageIndex];
  }
  
  if (!currentImage) {
    this.metadata = { error: 'No image available for metadata' };
    this.groupMetadata();
    this.metadataLoading = false;
    return;
  }
  
  this.metadataLoading = true;

  // Try to get base64 data and filename from the stored metadata images
  const imageIndex = this.loadedImages.findIndex(img => img.imageId === currentImage.imageId);
  
  if (imageIndex !== -1 && this.imagesWithMetadata.length > imageIndex) {
    const currentImageData = this.imagesWithMetadata[imageIndex];
    
    if (currentImageData.base64 && currentImageData.fileName) {
      const payload = {
        images: [{
          base64: currentImageData.base64,
          fileName: currentImageData.fileName
        }]
      };

      this.http.post(`${this.localApiURL}/fetch-metadata`, payload).subscribe({
        next: (resp: any) => {
          this.metadata = resp.metadata?.[0]?.metadata || {};
          this.groupMetadata();
          this.metadataLoading = false;
        },
        error: (error) => {
          // console.error('Failed to fetch metadata:', error);
          this.metadata = { error: 'Failed to load metadata' };
          this.groupMetadata();
          this.metadataLoading = false;
        }
      });
      return;
    }
  }

  // Fallback to DICOM data extraction if base64 is not available
  // For DICOM images with data
  if (currentImage.data && currentImage.data.string) {
    try {
      // Extract basic metadata from DICOM data
      this.metadata = {
        'Patient Name': currentImage.data.string('x00100010'),
        'Patient ID': currentImage.data.string('x00100020'),
        'Study Description': currentImage.data.string('x00081030'),
        'Series Description': currentImage.data.string('x0008103e'),
        'Modality': currentImage.data.string('x00080060'),
        'Study Date': currentImage.data.string('x00080020'),
        'Series Date': currentImage.data.string('x00080021'),
        'Image Date': currentImage.data.string('x00080023'),
        'Rows': currentImage.rows,
        'Columns': currentImage.columns,
        'Pixel Spacing': `${currentImage.rowPixelSpacing || 1} x ${currentImage.columnPixelSpacing || 1}`
      };
      
      this.groupMetadata();
      this.metadataLoading = false;
    } catch (error) {
      // console.error('Error extracting DICOM metadata:', error);
      this.metadata = { error: 'Failed to extract metadata from DICOM data' };
      this.groupMetadata();
      this.metadataLoading = false;
    }
  } else {
    // For regular images
    this.metadata = {
      'Image Type': 'Regular Image',
      'Width': currentImage.width,
      'Height': currentImage.height,
      'File Format': this.getImageFormat(currentImage.imageId)
    };
    
    this.groupMetadata();
    this.metadataLoading = false;
  }
}

private getImageFormat(imageId: string): string {
  if (!imageId) return 'UNKNOWN';
  
  // Check for data URL format
  if (imageId.startsWith('data:image/')) {
    const match = imageId.match(/data:image\/(\w+);/);
    return match ? match[1].toUpperCase() : 'UNKNOWN';
  }
  
  // Check for file extension
  const ext = imageId.split('.').pop()?.toUpperCase();
  return ext || 'UNKNOWN';
}

private groupMetadata() {
  this.groupedMetadata = {};
  
  if (!this.metadata || Object.keys(this.metadata).length === 0) return;
  
  // Check if we have nested metadata structure
  let metadataToProcess = this.metadata;
  
  // If metadata is nested under a 'metadata' property, use that
  if (this.metadata.metadata && typeof this.metadata.metadata === 'object') {
    metadataToProcess = this.metadata.metadata;
  }
  
  // If we have a flat structure with fileName, fileType, etc. at the top level
  if (this.metadata.fileName || this.metadata.fileType) {
    // Create General group for top-level properties
    this.groupedMetadata['General'] = [];
    
    Object.entries(this.metadata).forEach(([key, value]) => {
      // Skip the nested metadata object - we'll process it separately
      if (key === 'metadata' && typeof value === 'object') {
        return;
      }
      
      this.groupedMetadata['General'].push({ key, value });
    });
    
    // If there's nested metadata, process it too
    if (this.metadata.metadata && typeof this.metadata.metadata === 'object') {
      Object.entries(this.metadata.metadata).forEach(([key, value]) => {
        let groupName = 'General';
        
        if (key.toLowerCase().includes('patient')) groupName = 'Patient';
        if (key.toLowerCase().includes('study')) groupName = 'Study';
        if (key.toLowerCase().includes('series')) groupName = 'Series';
        if (key.toLowerCase().includes('image') || key.toLowerCase().includes('pixel')) groupName = 'Image';
        if (key.toLowerCase().includes('equipment')) groupName = 'Equipment';
        if (key.toLowerCase().includes('acquisition')) groupName = 'Acquisition';
        if (key.toLowerCase().includes('institution')) groupName = 'Institution';
        
        if (!this.groupedMetadata[groupName]) {
          this.groupedMetadata[groupName] = [];
        }
        
        this.groupedMetadata[groupName].push({ key, value });
      });
    }
    return;
  }
  
  // For regular DICOM metadata (flat structure)
  Object.entries(metadataToProcess).forEach(([key, value]) => {
    let groupName = 'General';
    
    if (key.toLowerCase().includes('patient')) groupName = 'Patient';
    if (key.toLowerCase().includes('study')) groupName = 'Study';
    if (key.toLowerCase().includes('series')) groupName = 'Series';
    if (key.toLowerCase().includes('image') || key.toLowerCase().includes('pixel')) groupName = 'Image';
    if (key.toLowerCase().includes('equipment')) groupName = 'Equipment';
    if (key.toLowerCase().includes('acquisition')) groupName = 'Acquisition';
    if (key.toLowerCase().includes('institution')) groupName = 'Institution';
    
    if (!this.groupedMetadata[groupName]) {
      this.groupedMetadata[groupName] = [];
    }
    
    this.groupedMetadata[groupName].push({ key, value });
  });
}

// Change this method from private to public
public formatMetadataValue(value: any): string {
  if (value === null || value === undefined) {
    return 'N/A';
  }
  
  if (typeof value === 'object') {
    try {
      return JSON.stringify(value, null, 2);
    } catch (e) {
      return '[Object]';
    }
  }
  
  return value.toString();
}

public hasGroupedMetadata(): boolean {
  if (!this.groupedMetadata) {
    return false;
  }
  
  // Check if we have any groups with content
  const groupKeys = this.getGroupKeys();
  if (groupKeys.length === 0) {
    return false;
  }
  
  // Check if at least one group has items
  return groupKeys.some(groupName => 
    this.groupedMetadata[groupName] && this.groupedMetadata[groupName].length > 0
  );
}

  public getGroupKeys(): string[] {
    if (!this.groupedMetadata) {
      return [];
    }
    try {
      return Object.keys(this.groupedMetadata);
    } catch (error) {
      // console.error('Error getting group keys:', error);
      return [];
    }
  }


  private configureCornerstone(): void {
    cornerstoneWebImageLoader.external.cornerstone = cornerstone;
    cornerstoneWebImageLoader.external.dicomParser = dicomParser;

    cornerstoneTools.init({
      showSVGCursors: true,
      globalToolSyncEnabled: true
    });

    cornerstoneTools.addTool(cornerstoneTools.CrosshairsTool);

    // cornerstoneWADOImageLoader.webWorkerManager.initialize({
    //   maxWebWorkers: navigator.hardwareConcurrency || 4,
    //   webWorkerPath: '/assets/cornerstone/webworkers/cornerstoneWADOImageLoaderWebWorker.js',
    //   taskConfiguration: {
    //     decodeTask: {
    //       codecsPath: '/assets/cornerstone/codecs/cornerstoneWADOImageLoaderCodecs.js'
    //     }
    //   }
    // });

    cornerstoneWebImageLoader.configure({
      useWebWorkers: true,
      decodeConfig: {
        convertFloatPixelDataToInt: false,
        use16BitDataType: false
      }
    });
  }

  switchView(view: '2d' | '3d'): void {
    this.activeView = view;
    if (view === '3d') {
      this.errorMessage = '3D rendering is not fully supported in this version';
      // console.warn('3D rendering requires additional setup');
    }
  }


  public loadMoreImages() {
    this.element = this.viewPort.element;
    const maxImages = (this.maxImagesToLoad <= 0) ? (this.imageIdList.length - this.loadedImages.length) : Math.min(this.maxImagesToLoad, this.imageIdList.length - this.loadedImages.length);
    this.loadingImages = true;
    this.targetImageCount += maxImages;
    let nextImageIndex = this.loadedImages.length;
    for (let index = 0; index < maxImages; index++) {
      const imageId = this.imageIdList[nextImageIndex++];
      cornerstone.loadAndCacheImage(imageId)
        .then(imageData => { this.imageLoaded(imageData) })
        .catch(err => { this.targetImageCount--; });
    }
  }

  private imageLoaded(imageData) {
  if (!imageData) return;

  // Set default pixel spacing if missing
  if (!imageData.rowPixelSpacing && !imageData.columnPixelSpacing) {
    imageData.rowPixelSpacing = 1;
    imageData.columnPixelSpacing = 1;
  }

  this.loadedImages.push(imageData);
  this.totalImages = this.loadedImages.length;

  // For regular images (non-DICOM)
  if (!imageData.data || !imageData.data.string) {
    const series = {
      studyID: 'regular-images',
      seriesID: 'regular-images-' + this.loadedImages.length,
      seriesNumber: 0,
      studyDescription: 'Regular Images',
      seriesDescription: 'Image ' + (this.loadedImages.length + 1),
      imageCount: 1,
      imageList: [imageData]
    };
    
    this.seriesList.push(series);
    
    if (!this.crosshairModeEnabled && this.seriesList.length === 1) {
      this.showSeries(0);
    }
    return;
  }
  
  // Handle DICOM/IMA images
  try {
    const series = {
      studyID: imageData.data.string('x0020000d'),
      seriesID: imageData.data.string('x0020000e'),
      seriesNumber: imageData.data.intString('x00200011'),
      studyDescription: imageData.data.string('x00081030'),
      seriesDescription: imageData.data.string('x0008103e'),
      imageCount: 1,
      imageList: [imageData]
    };
    
    let seriesIndex = this.seriesList.findIndex(item => item.seriesID === series.seriesID);
    if (seriesIndex < 0) {
      seriesIndex = this.seriesList.length;
      this.seriesList.push(series);
      this.seriesList.sort((a, b) => a.seriesNumber - b.seriesNumber);
    } else {
      this.seriesList[seriesIndex].imageCount++;
      this.seriesList[seriesIndex].imageList.push(imageData);
      this.seriesList[seriesIndex].imageList.sort((a, b) => 
        a.data.intString('x00200013') - b.data.intString('x00200013'));
    }

    if (!this.crosshairModeEnabled && seriesIndex === this.currentSeriesIndex) {
      this.showSeries(this.currentSeriesIndex);
    }
  } catch (error) {
    // console.error('Error processing DICOM image:', error);
  }

  if (this.loadedImages.length >= this.targetImageCount) {
    this.loadingImages = false;
    if (this.crosshairModeEnabled && this.loadedImages.length > 1) {
      this.viewPort.addAllImagesForCrosshairs(this.loadedImages);
      this.enableCrosshairs();
    }
  }
}
print(){
   if (!this.element) return;
  
  // Get all canvases in the viewport with proper typing
  const canvases = this.element.querySelectorAll('canvas') as NodeListOf<HTMLCanvasElement>;
  if (canvases.length === 0) return;
  
  // Create a temporary canvas to merge layers
  const tempCanvas = document.createElement('canvas');
  const tempCtx = tempCanvas.getContext('2d');
  if (!tempCtx) return;
  
  // Set dimensions
  tempCanvas.width = canvases[0].width;
  tempCanvas.height = canvases[0].height;
  
  // Draw all layers with proper typing
  Array.from(canvases).forEach((canvas: HTMLCanvasElement) => {
    tempCtx.drawImage(canvas, 0, 0);
  });
  const imgDataUrl = tempCanvas.toDataURL('image/png');

  this.dataEvent.emit(imgDataUrl);

}



  public async saveAs() {
  if (!this.element) return;

  // Open the native "Save As" dialog first (must run directly in the click gesture)
  let fileHandle: any = null;
  const win: any = window;
  if (typeof win.showSaveFilePicker === 'function') {
    try {
      fileHandle = await win.showSaveFilePicker({
        suggestedName: 'AnnotatedImage.jpeg',
        types: [{ description: 'JPEG Image', accept: { 'image/jpeg': ['.jpeg', '.jpg'] } }]
      });
    } catch (err) {
      // User cancelled the dialog
      if (err && err.name === 'AbortError') return;
      fileHandle = null;
    }
  }

  // Get all canvases in the viewport with proper typing
  const canvases = this.element.querySelectorAll('canvas') as NodeListOf<HTMLCanvasElement>;
  if (canvases.length === 0) return;
  
  // Create a temporary canvas to merge layers
  const tempCanvas = document.createElement('canvas');
  const tempCtx = tempCanvas.getContext('2d');
  if (!tempCtx) return;
  
  // Set dimensions
  tempCanvas.width = canvases[0].width;
  tempCanvas.height = canvases[0].height;
  
  // Draw all layers with proper typing
  Array.from(canvases).forEach((canvas: HTMLCanvasElement) => {
    tempCtx.drawImage(canvas, 0, 0);
  });
  
  // Write to the location chosen by the user
  if (fileHandle) {
    const blob = await new Promise<Blob>(resolve => tempCanvas.toBlob(b => resolve(b), 'image/jpeg'));
    const writable = await fileHandle.createWritable();
    await writable.write(blob);
    await writable.close();
    return;
  }

  // Fallback for browsers without the Save As dialog support: plain download
  const link = document.createElement('a');
  link.href = tempCanvas.toDataURL('image/jpeg');
  link.download = 'AnnotatedImage.jpeg';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}

public nextImage() {
  if (this.currentImageIndex < this.totalImages - 1) {
    this.currentImageIndex++;
    this.displayCurrentImage();
  }
}

public previousImage() {
  if (this.currentImageIndex > 0) {
    this.currentImageIndex--;
    this.displayCurrentImage();
  }
}

public displayCurrentImage() {
  if (!this.viewPort || this.loadedImages.length === 0) {
    this.viewPort?.resetViewer();
    return;
  }

  this.currentImageIndex = Math.max(0, Math.min(this.currentImageIndex, this.totalImages - 1));
  const currentImage = this.loadedImages[this.currentImageIndex];
  
  // Reset and display new image
  this.viewPort.resetImageCache();
  this.viewPort.addImageData(currentImage);
  this.viewPort.currentIndex = this.currentImageIndex;

  // Force a resize to ensure proper display
  setTimeout(() => {
    cornerstone.resize(this.element, true);
  }, 50);
}

public showSeries(index: number) {
  if (index < 0 || index >= this.seriesList.length) return;

  this.currentSeriesIndex = index;
  this.currentSeries = this.seriesList[index];
  this.imageCount = this.currentSeries.imageCount;

  // Reset and display the image
  this.viewPort.resetImageCache();
  this.viewPort.addImageData(this.currentSeries.imageList[0]);
  this.currentImageIndex = this.getGlobalImageIndex(index, 0);

  // Refresh view
  setTimeout(() => {
    cornerstone.updateImage(this.element);
    cornerstone.resize(this.element, true);
  }, 100);
}

public getImageName(image: any): string {
  if (!image) return 'Unknown';
  
  // For DICOM images
  if (image.data && image.data.string) {
    return image.data.string('x0008103e') || // Series Description
           image.data.string('x00080018') || // SOP Instance UID
           'DICOM Image';
  }
  
  // For regular images, extract from URL
  if (image.imageId) {
    const parts = image.imageId.split('/');
    return parts[parts.length - 1] || 'Image';
  }
  
  return 'Image';
}

private getGlobalImageIndex(seriesIndex: number, imageIndex: number): number {
  let globalIndex = 0;
  for (let i = 0; i < seriesIndex; i++) {
    globalIndex += this.seriesList[i].imageCount;
  }
  return globalIndex + imageIndex;
}

public getLoadedImages(): any[] {
  return this.loadedImages;
}

public addImageToLoadedImages(image: any) {
  this.loadedImages.push(image);
  this.totalImages = this.loadedImages.length;
  
}


 public resetAllTools() {
  if (this.imageCount > 0 && this.element) {
    const toolsToDeactivate = [
      'Wwwc', 'Pan', 'Zoom', 'Probe', 'Length', 'Angle', 'Magnify',
      'EllipticalRoi', 'RectangleRoi', 'StackScroll', 'Rotate',
      'CobbAngle', 'FreehandRoi', 'ArrowAnnotate', 'TextMarker',
      'ScaleOverlay', 'Crosshairs', 'StackScrollMouseWheel'
    ];

    toolsToDeactivate.forEach(toolName => {
      try {
        // Set to passive instead of disabled
        cornerstoneTools.setToolPassiveForElement(this.element, toolName);
        this.activeTools[toolName] = false;
      } catch (error) {
        // console.warn(`Error disabling tool ${toolName}:`, error);
      }
    });
    
    this.stopClip();
  }
}


// Windowing Tool
public enableWindowing() {
  if (this.imageCount > 0) {
    if (this.isToolActive('Wwwc')) {
      cornerstoneTools.setToolPassiveForElement(this.element, 'Wwwc');
      this.activeTools['Wwwc'] = false;
      this.resetCursor(); 
    } else {
      this.deactivateOtherTools('Wwwc');
      cornerstoneTools.setToolActiveForElement(this.element, 'Wwwc', { mouseButtonMask: 1 }, ['Mouse']);
      this.activeTools['Wwwc'] = true;
    }
  }
}

// Update the enableZoom method to only handle zoom
public enableZoom() {
  if (this.imageCount > 0) {
    if (this.isToolActive('Zoom')) {
      cornerstoneTools.setToolPassiveForElement(this.element, 'Zoom');
      this.activeTools['Zoom'] = false;
      this.resetCursor(); 
    } else {
      this.deactivateOtherTools('Zoom');
      cornerstoneTools.setToolActiveForElement(this.element, 'Zoom', { mouseButtonMask: 1 }, ['Mouse']);
      this.activeTools['Zoom'] = true;
    }
  }
}

// Update the enablePan method to only handle pan
public enablePan() {
  if (this.imageCount > 0) {
    if (this.isToolActive('Pan')) {
      cornerstoneTools.setToolPassiveForElement(this.element, 'Pan');
      this.activeTools['Pan'] = false;
      this.resetCursor(); 
    } else {
      this.deactivateOtherTools('Pan');
      cornerstoneTools.setToolActiveForElement(this.element, 'Pan', { mouseButtonMask: 1 }, ['Mouse']);
      this.activeTools['Pan'] = true;
    }
  }
}

// Update the enableScroll method to only handle scroll
public enableScroll() {
  if (this.imageCount > 0) {
    if (this.isToolActive('StackScroll')) {
      cornerstoneTools.setToolPassiveForElement(this.element, 'StackScroll');
      this.activeTools['StackScroll'] = false;
      this.resetCursor(); 
    } else {
      this.deactivateOtherTools('StackScroll');
      cornerstoneTools.setToolActiveForElement(this.element, 'StackScroll', { mouseButtonMask: 1 }, ['Mouse']);
      this.activeTools['StackScroll'] = true;
    }
  }
}


// Angle Tool
public enableAngle() {
  if (this.imageCount > 0) {
    if (this.isToolActive('Angle')) {
      cornerstoneTools.setToolPassiveForElement(this.element, 'Angle');
      this.activeTools['Angle'] = false;
      this.resetCursor(); 
    } else {
      this.deactivateOtherTools('Angle');
      cornerstoneTools.setToolActiveForElement(this.element, 'Angle', { mouseButtonMask: 1 }, ['Mouse']);
      this.activeTools['Angle'] = true;
    }
  }
}

// Probe Tool
public enableProbe() {
  if (this.imageCount > 0) {
    if (this.isToolActive('Probe')) {
      cornerstoneTools.setToolPassiveForElement(this.element, 'Probe');
      this.activeTools['Probe'] = false;
      this.resetCursor(); 
    } else {
      this.deactivateOtherTools('Probe');
      cornerstoneTools.setToolActiveForElement(this.element, 'Probe', { mouseButtonMask: 1 }, ['Mouse']);
      this.activeTools['Probe'] = true;
    }
  }
}

// Update measurement tools to not automatically deactivate others

public enableLength() {
  if (this.imageCount > 0) {
    if (this.isToolActive('Length')) {
      cornerstoneTools.setToolPassiveForElement(this.element, 'Length'); // ← Passive keeps annotations
      this.activeTools['Length'] = false;
      this.resetCursor(); 
    } else {
      this.deactivateOtherTools('Length');
      cornerstoneTools.setToolActiveForElement(this.element, 'Length', { mouseButtonMask: 1 }, ['Mouse']);
      this.activeTools['Length'] = true;
    }
  }
}


public enableElliptical() {
  if (this.imageCount > 0) {
    if (this.isToolActive('EllipticalRoi')) {
      cornerstoneTools.setToolPassiveForElement(this.element, 'EllipticalRoi');
      this.activeTools['EllipticalRoi'] = false;
      this.resetCursor(); 
    } else {
      this.deactivateOtherTools('EllipticalRoi');
      cornerstoneTools.setToolActiveForElement(this.element, 'EllipticalRoi', { mouseButtonMask: 1 }, ['Mouse']);
      this.activeTools['EllipticalRoi'] = true;
    }
  }
}




public enableRectangle() {
  if (this.imageCount > 0) {
    if (this.isToolActive('RectangleRoi')) {
      cornerstoneTools.setToolPassiveForElement(this.element, 'RectangleRoi');
      this.activeTools['RectangleRoi'] = false;
      this.resetCursor(); 
    } else {
      this.deactivateOtherTools('RectangleRoi');
      cornerstoneTools.setToolActiveForElement(this.element, 'RectangleRoi', { mouseButtonMask: 1 }, ['Mouse']);
      this.activeTools['RectangleRoi'] = true;
    }
  }
}

public refreshAnnotations() {
  // Force redraw of all annotations
  cornerstone.updateImage(this.element);
  
  // Re-enable all measurement tools (without activating them)
  [...this.MEASUREMENT_TOOLS, ...this.ANNOTATION_TOOLS].forEach(tool => {
    const toolState = cornerstoneTools.getToolState(this.element, tool);
    if (toolState && toolState.data.length > 0) {
      cornerstoneTools.setToolEnabledForElement(this.element, tool);
    }
  });
}

// Rotate Tool
public enableRotate() {
  if (this.imageCount > 0) {
    if (this.isToolActive('Rotate')) {
      cornerstoneTools.setToolPassiveForElement(this.element, 'Rotate');
      this.activeTools['Rotate'] = false;
      this.resetCursor(); 
    } else {
      this.deactivateOtherTools('Rotate');
      cornerstoneTools.setToolActiveForElement(this.element, 'Rotate', { mouseButtonMask: 1 }, ['Mouse']);
      this.activeTools['Rotate'] = true;
    }
  }
}

// Flip Horizontal
public enableFlipH() {
  if (this.imageCount > 0) {
    const viewport = cornerstone.getViewport(this.element);
    viewport.hflip = !viewport.hflip;
    cornerstone.setViewport(this.element, viewport);
    this.activeTools['FlipH'] = viewport.hflip;
  }
}

// Flip Vertical
public enableFlipV() {
  if (this.imageCount > 0) {
    const viewport = cornerstone.getViewport(this.element);
    viewport.vflip = !viewport.vflip;
    cornerstone.setViewport(this.element, viewport);
    this.activeTools['FlipV'] = viewport.vflip;
  }
}

public enableCrosshairs(): boolean {
  if (this.loadedImages.length < 2) {
    this.errorMessage = 'Crosshairs require at least two images';
    return false;
  }

  try {
    // First disable any existing crosshairs
    this.viewPort.disableCrosshairs();
    
    // Enable crosshairs in the viewport
    const success = this.viewPort.enableCrosshairs();
    
    if (success) {
      this.activeTools['Crosshairs'] = true;
      this.activeTools['StackScroll'] = true;
      this.errorMessage = '';
      return true;
    } else {
      this.errorMessage = 'Failed to enable crosshairs';
      return false;
    }
  } catch (error) {
    // console.error('Error enabling crosshairs:', error);
    this.errorMessage = 'Failed to enable crosshairs';
    return false;
  }
}

public disableCrosshairs() {
  cornerstoneTools.setToolDisabledForElement(this.element, 'Crosshairs');
  cornerstoneTools.setToolDisabledForElement(this.element, 'StackScroll');
  this.activeTools['Crosshairs'] = false;
  this.activeTools['StackScroll'] = false;
  this.errorMessage = '';
}

public onViewportImageIndexChange(newIndex: number) {
  // Update the current image index to keep thumbnails synchronized
  if (newIndex >= 0 && newIndex < this.loadedImages.length) {
    this.currentImageIndex = newIndex;
    
    // If metadata panel is open, refresh it with the new image's metadata
    if (this.showMetadata) {
      this.fetchMetadata();
    }
  }
}

public enableStackScrollWheel(): boolean {
  // Only proceed if manually enabled
  if (!this.stackScrollManuallyEnabled) return false;

  // Verify requirements
  if (!this.element || !this.viewPort || this.loadedImages.length < 2) {
    // console.warn('Stack scroll requirements not met');
    return false;
  }

  try {
    // Sync directive with current images
    this.viewPort.syncWithViewer(this.loadedImages);

    // Initialize stack state
    const stack = {
      currentImageIdIndex: this.currentImageIndex, // Use current index
      imageIds: this.loadedImages.map(img => img.imageId),
      frameRate: 15
    };
    
    cornerstoneTools.addStackStateManager(this.element, ['stack']);
    cornerstoneTools.addToolState(this.element, 'stack', stack);

    // Activate through directive
    const success = this.viewPort.enableStackScrollWheel();
    
    if (success) {
      // Make sure the viewport starts at the correct index
      this.viewPort.currentIndex = this.currentImageIndex;
      if (this.loadedImages[this.currentImageIndex]) {
        this.viewPort.displayImage(this.loadedImages[this.currentImageIndex]);
      }
    }
    
    return success;
  } catch (error) {
    // console.error('Stack scroll activation failed:', error);
    return false;
  }
}

public toggleStackScrollWheel() {
  this.stackScrollManuallyEnabled = !this.stackScrollManuallyEnabled;
  
  if (this.stackScrollManuallyEnabled) {
    // Only enable if we have enough images
    if (this.loadedImages.length >= 2) {
      this.enableStackScrollWheel();
    }
  } else {
    this.viewPort.disableStackScrollWheelCompletely();
  }
}


public disableStackScrollWheelCompletely() {
  this.viewPort.disableStackScrollWheelCompletely();
  this.activeTools['StackScrollMouseWheel'] = false;
}




// Magnify Tool
public enableMagnify() {
  if (this.imageCount > 0) {
    if (this.isToolActive('Magnify')) {
      cornerstoneTools.setToolPassiveForElement(this.element, 'Magnify');
      this.activeTools['Magnify'] = false;
      this.resetCursor(); 
    } else {
      this.deactivateOtherTools('Magnify');
      cornerstoneTools.setToolActiveForElement(this.element, 'Magnify', { mouseButtonMask: 1 }, ['Mouse']);
      this.activeTools['Magnify'] = true;
    }
  }
}

// Scale Overlay Tool
public enableScaleOverlay() {
  if (this.imageCount > 0) {
    if (this.isToolActive('ScaleOverlay')) {
      cornerstoneTools.setToolPassiveForElement(this.element, 'ScaleOverlay');
      this.activeTools['ScaleOverlay'] = false;
      this.resetCursor(); 
    } else {
      this.deactivateOtherTools('ScaleOverlay');
      cornerstoneTools.setToolActiveForElement(this.element, 'ScaleOverlay', { mouseButtonMask: 1 }, ['Mouse']);
      this.activeTools['ScaleOverlay'] = true;
    }
  }
}

// Cobb Angle Tool
public enableCobbAngle() {
  if (this.imageCount > 0) {
    if (this.isToolActive('CobbAngle')) {
      cornerstoneTools.setToolPassiveForElement(this.element, 'CobbAngle');
      this.activeTools['CobbAngle'] = false;
      this.resetCursor(); 
    } else {
      this.deactivateOtherTools('CobbAngle');
      cornerstoneTools.setToolActiveForElement(this.element, 'CobbAngle', { mouseButtonMask: 1 }, ['Mouse']);
      this.activeTools['CobbAngle'] = true;
    }
  }
}

// Freehand ROI Tool
public enableFreehandRoi() {
  if (this.imageCount > 0) {
    if (this.isToolActive('FreehandRoi')) {
      cornerstoneTools.setToolPassiveForElement(this.element, 'FreehandRoi');
      this.activeTools['FreehandRoi'] = false;
      this.resetCursor(); 
    } else {
      this.deactivateOtherTools('FreehandRoi');
      cornerstoneTools.setToolActiveForElement(this.element, 'FreehandRoi', { mouseButtonMask: 1 }, ['Mouse']);
      this.activeTools['FreehandRoi'] = true;
    }
  }
}



public toggleFreehandEditMode() {
  const toolState = cornerstoneTools.getToolState(this.element, 'FreehandRoi');
  if (toolState && toolState.data.length > 0) {
    // Toggle edit mode on all existing ROIs
    toolState.data.forEach(roi => {
      roi.handles.activeHandleIndex = roi.handles.activeHandleIndex === null ? 0 : null;
    });
    cornerstone.updateImage(this.element);
  }
}

public deleteSelectedFreehand() {
  const toolState = cornerstoneTools.getToolState(this.element, 'FreehandRoi');
  if (toolState && toolState.data.length > 0) {
    // Find the active ROI (the one being edited)
    const activeIndex = toolState.data.findIndex(
      roi => roi.handles.activeHandleIndex !== null
    );
    
    if (activeIndex !== -1) {
      cornerstoneTools.removeToolState(this.element, 'FreehandRoi', toolState.data[activeIndex]);
      cornerstone.updateImage(this.element);
    }
  }
}


public enableEraser() {
  if (this.imageCount > 0) {
    if (this.isToolActive('Eraser')) {
      cornerstoneTools.setToolPassiveForElement(this.element, 'Eraser');
      this.activeTools['Eraser'] = false;
      this.resetCursor(); 
    } else {
      this.deactivateOtherTools('Eraser');
      cornerstoneTools.setToolActiveForElement(
        this.element, 
        'Eraser', 
        { 
          mouseButtonMask: 1,
          configuration: {
            // Allow erasing all annotation types
            toolTypes: [
              'Length', 'Angle', 'Probe', 'EllipticalRoi', 'RectangleRoi',
              'CobbAngle', 'FreehandRoi', 'ArrowAnnotate', 'TextMarker'
            ]
          }
        }, 
        ['Mouse']
      );
      this.activeTools['Eraser'] = true;
    }
  }
}

public eraseAllAnnotations() {
  if (this.imageCount > 0) {
    const toolsToClear = [
      'Length', 'Angle', 'EllipticalRoi', 'RectangleRoi',
      'CobbAngle', 'FreehandRoi', 'ArrowAnnotate', 'TextMarker'
    ];
    
    toolsToClear.forEach(tool => {
      cornerstoneTools.clearToolState(this.element, tool);
    });
    
    cornerstone.updateImage(this.element);
  }
}


// Arrow Annotate Tool
public enableArrowAnnotate() {
  if (this.imageCount > 0) {
    if (this.isToolActive('ArrowAnnotate')) {
      cornerstoneTools.setToolPassiveForElement(this.element, 'ArrowAnnotate');
      this.activeTools['ArrowAnnotate'] = false;
    } else {
      this.deactivateOtherTools('ArrowAnnotate');
      cornerstoneTools.setToolActiveForElement(this.element, 'ArrowAnnotate', { mouseButtonMask: 1 }, ['Mouse']);
      this.activeTools['ArrowAnnotate'] = true;
    }
  }
}

// Text Marker Tool
public enableTextMarker() {
  if (this.imageCount > 0) {
    if (this.isToolActive('TextMarker')) {
      cornerstoneTools.setToolPassiveForElement(this.element, 'TextMarker');
      this.activeTools['TextMarker'] = false;
      this.resetCursor(); 
    } else {
      this.deactivateOtherTools('TextMarker');
      cornerstoneTools.setToolActiveForElement(this.element, 'TextMarker', { mouseButtonMask: 1 }, ['Mouse']);
      this.activeTools['TextMarker'] = true;
    }
  }
}

// Mouse Wheel Scroll Tool
  public playClip() {
    if (this.imageCount > 0) {
      let frameRate = 10;
      let stackState = cornerstoneTools.getToolState(this.element, 'stack');
      if (stackState) {
        frameRate = stackState.data[0].frameRate || 10;
      }
      cornerstoneTools.playClip(this.element, frameRate);
    }
  }

  public stopClip() {
    cornerstoneTools.stopClip(this.element);
  }

  public invertImage() {
    if (this.imageCount > 0) {
      let viewport = cornerstone.getViewport(this.element);
      viewport.invert = !viewport.invert;
      cornerstone.setViewport(this.element, viewport);
    }
  }

public resetImage() {
  // Clear all measurement annotations
  [...this.MEASUREMENT_TOOLS, ...this.ANNOTATION_TOOLS].forEach(tool => {
    cornerstoneTools.clearToolState(this.element, tool);
  });
  
  // Reset viewport settings
  if (this.imageCount > 0) {
    const viewport = cornerstone.getViewport(this.element);
    viewport.invert = false;
    viewport.hflip = false;
    viewport.vflip = false;
    cornerstone.setViewport(this.element, viewport);
    cornerstone.updateImage(this.element);
  }
  
  this.stopClip();
  this.refreshAnnotations();
}

private readonly VIEW_MANIPULATION_TOOLS = ['Zoom', 'Pan', 'StackScroll', 'StackScrollMouseWheel', 'Rotate'];
private readonly MEASUREMENT_TOOLS = ['Length', 'Angle', 'Probe', 'EllipticalRoi', 'RectangleRoi', 'CobbAngle', 'FreehandRoi'];
private readonly ANNOTATION_TOOLS = ['TextMarker', 'ArrowAnnotate'];
private readonly ERASER_TOOL = ['Eraser'];
private readonly SPECIAL_TOOLS = ['Wwwc', 'Magnify', 'ScaleOverlay', 'Crosshairs', 'StackScrollMouseWheel'];

// Modified deactivateOtherTools method
private deactivateOtherTools(currentTool: string) {
  // Deactivate all tools except the current one
  const allTools = [
    ...this.VIEW_MANIPULATION_TOOLS, 
    ...this.MEASUREMENT_TOOLS, 
    ...this.ANNOTATION_TOOLS,
    ...this.SPECIAL_TOOLS,
    ...this.ERASER_TOOL
  ];

  allTools
    .filter(t => t !== currentTool)
    .forEach(tool => {
      if (this.activeTools[tool]) {
        cornerstoneTools.setToolPassiveForElement(this.element, tool);
        this.activeTools[tool] = false;
      }
    });
}

public deactivateAllTools() {
  if (this.imageCount > 0 && this.element) {
    const toolsToDeactivate = [
      'Wwwc', 'Pan', 'Zoom', 'Probe', 'Length', 'Angle', 'Magnify',
      'EllipticalRoi', 'RectangleRoi', 'StackScroll', 'Rotate',
      'CobbAngle', 'FreehandRoi', 'ArrowAnnotate', 'TextMarker',
      'ScaleOverlay', 'Crosshairs', 'StackScrollMouseWheel', 'Eraser'
    ];

    toolsToDeactivate.forEach(toolName => {
      try {
        cornerstoneTools.setToolPassiveForElement(this.element, toolName);
        this.activeTools[toolName] = false;
        this.resetCursor(); 
      } catch (error) {
        // console.warn(`Error disabling tool ${toolName}:`, error);
      }
    });
    
    // Reset cursor to default
    this.resetCursor();
    this.stopClip();
  }
}

private resetCursor() {
  // Reset the cursor to default
  if (this.element) {
    this.element.style.cursor = 'default';
  }
}

public clearImage() {
  if (this.loadedImages.length === 0) return;

  // Get the image to be deleted
  const imageToDelete = this.loadedImages[this.currentImageIndex];
  if (!imageToDelete) return;

  // 1. Remove from loadedImages array
  this.loadedImages.splice(this.currentImageIndex, 1);
  this.totalImages = this.loadedImages.length;

  // 2. Update currentImageIndex
  if (this.currentImageIndex >= this.totalImages) {
    this.currentImageIndex = Math.max(0, this.totalImages - 1);
  }

  // 3. Remove from seriesList
  this.seriesList.forEach(series => {
    const imageIndex = series.imageList.findIndex(img => img.imageId === imageToDelete.imageId);
    if (imageIndex !== -1) {
      series.imageList.splice(imageIndex, 1);
      series.imageCount = series.imageList.length;
    }
  });

  // 4. Remove empty series
  this.seriesList = this.seriesList.filter(series => series.imageCount > 0);

  // 5. Update UI based on remaining images
  if (this.seriesList.length > 0) {
    // Find new series index
    let newSeriesIndex = 0;
    let cumulativeCount = 0;
    for (let i = 0; i < this.seriesList.length; i++) {
      if (this.currentImageIndex < cumulativeCount + this.seriesList[i].imageCount) {
        newSeriesIndex = i;
        break;
      }
      cumulativeCount += this.seriesList[i].imageCount;
    }

    this.currentSeriesIndex = newSeriesIndex;
    this.currentSeries = this.seriesList[newSeriesIndex];
    this.imageCount = this.currentSeries.imageCount;

    // Update viewport
    this.viewPort.resetImageCache();
    this.displayCurrentImage();
  } else {
    // No images left - reset everything
    this.resetViewerState();
  }

  // 6. Notify parent component to update thumbnails
  this.notifyThumbnailUpdate(imageToDelete.imageId);
}

private resetViewerState() {
  this.imageIdList = [];
  this.seriesList = [];
  this.currentSeries = {};
  this.imageCount = 0;
  this.viewPort.resetViewer();
  this.viewPort.resetImageCache();
}

private notifyThumbnailUpdate(deletedImageId: string) {

  setTimeout(() => {
    // This forces the thumbnail viewer to refresh
    if (this.thumbnails) {
      this.thumbnails.forEach(thumb => thumb.refresh());
    }
  }, 100);
}



public removeImageById(imageId: string) {
  // Remove from loadedImages
  const imageIndex = this.loadedImages.findIndex(img => img.imageId === imageId);
  if (imageIndex !== -1) {
    this.loadedImages.splice(imageIndex, 1);
    this.totalImages = this.loadedImages.length;
    
    // Update currentImageIndex if needed
    if (this.currentImageIndex >= this.totalImages) {
      this.currentImageIndex = Math.max(0, this.totalImages - 1);
    }
  }

  // Remove from seriesList
  this.seriesList.forEach(series => {
    const seriesImageIndex = series.imageList.findIndex(img => img.imageId === imageId);
    if (seriesImageIndex !== -1) {
      series.imageList.splice(seriesImageIndex, 1);
      series.imageCount = series.imageList.length;
    }
  });

  // Remove empty series
  this.seriesList = this.seriesList.filter(series => series.imageCount > 0);

  // Update view if needed
  if (this.totalImages > 0) {
    this.displayCurrentImage();
  } else {
    this.resetViewerState();
  }
}

public selectImage(image: any) {
  if (!image) return;

  // Find the index of the selected image
  const imageIndex = this.loadedImages.findIndex(img => img.imageId === image.imageId);
  
  if (imageIndex === -1) {
    // console.warn('Image not found in loaded images');
    return;
  }

  this.currentImageIndex = imageIndex;
  
  // Reset and display the new image
  this.viewPort.resetImageCache();
  this.viewPort.addImageData(image);
  this.viewPort.currentIndex = this.currentImageIndex;

  // Update series information if needed
  this.updateSeriesForCurrentImage();

  // Force a resize to ensure proper display
  setTimeout(() => {
    cornerstone.resize(this.element, true);
  }, 50);
}

private updateSeriesForCurrentImage() {
  if (!this.loadedImages[this.currentImageIndex]) return;

  const currentImage = this.loadedImages[this.currentImageIndex];
  const currentImageId = currentImage.imageId;

  // Find which series contains this image
  for (let i = 0; i < this.seriesList.length; i++) {
    const series = this.seriesList[i];
    const imageInSeries = series.imageList.find(img => img.imageId === currentImageId);
    
    if (imageInSeries) {
      this.currentSeriesIndex = i;
      this.currentSeries = series;
      this.imageCount = series.imageCount;
      
      // Find the position within the series
      const seriesImageIndex = series.imageList.findIndex(img => img.imageId === currentImageId);
      this.viewPort.currentIndex = seriesImageIndex;
      break;
    }
  }
}

public clearMetadata() {
  this.metadata = {};
  this.groupedMetadata = {};
  this.metadataLoading = false;
}

//new updated method

public loadStudyImages(images: any[]) {
  // Reset viewer state
  this.selectedImage = null;
  this.element = this.viewPort.element;
  this.clearMetadata();
 
  // Store images with their base64 data for metadata fetching
  this.imagesWithMetadata = images
    .map(img => ({
      imageId: img.imageId,
      base64: img.base64 || '',
      fileName: img.fileName || img.seriesDescription || 'unknown',
    }))
    .filter(img => img.base64); // Only keep images that have base64 data
 
  // Extract image IDs safely
  this.imageIdList = images
    .map(img => (img.isApiImage ? img.dataUrl || img.imageId || '' : img.imageId || ''))
    .filter(id => id !== '');
 
  // Reset viewport and internal state
  this.viewPort.resetViewer();
  this.viewPort.resetImageCache();
  this.seriesList = [];
  this.currentSeriesIndex = 0;
  this.loadedImages = [];
  this.loadingImages = true;
  this.targetImageCount = images.length;
 
  // Function to load a single image
  const loadImage = (image: any): Promise<any> => {
    return new Promise((resolve, reject) => {
      // Handle API images (blob or data URL)
      if (image.isApiImage) {
        if (image.blob) {
          this.convertBlobToImageData(image.blob, image.seriesDescription)
            .then(imageData => resolve(imageData))
            .catch(err => reject(err));
        } else if (image.dataUrl) {
          this.convertDataUrlToImageData(image.dataUrl, image.seriesDescription)
            .then(imageData => resolve(imageData))
            .catch(err => reject(err));
        } else {
          reject(new Error('API image has no blob or data URL'));
        }
        return;
      }
 
      // Handle standard image (PNG/JPG)
      const imageId = image.imageId || '';
      const resolvedImageId = imageId.startsWith('/view-image/')
        ? `${this.localApiURL}${imageId}`
        : imageId;
 
      const img = new Image();
      img.crossOrigin = 'Anonymous';
      img.onload = () => {
        const imageData = {
          imageId: resolvedImageId,
          minPixelValue: 0,
          maxPixelValue: 255,
          slope: 1,
          intercept: 0,
          windowCenter: 128,
          windowWidth: 256,
          getPixelData: () => {
            const canvas = document.createElement('canvas');
            canvas.width = img.width;
            canvas.height = img.height;
            const ctx = canvas.getContext('2d');
            if (ctx) {
              ctx.drawImage(img, 0, 0);
              return ctx.getImageData(0, 0, img.width, img.height).data;
            }
            return new Uint8Array(0);
          },
          getImage: () => img,
          rows: img.height,
          columns: img.width,
          height: img.height,
          width: img.width,
          color: true,
          rgba: true,
          sizeInBytes: img.width * img.height * 4,
          rowPixelSpacing: 1,
          columnPixelSpacing: 1,
          seriesDescription: image.seriesDescription,
        };
        resolve(imageData);
      };
      let objectUrl: string | null = null;
      img.onerror = () => {
        if (objectUrl) {
          URL.revokeObjectURL(objectUrl);
        }
        reject(new Error(`Failed to load image: ${resolvedImageId}`));
      };

      // Fetch the converted JPEG through HttpClient (same path as /process-base64) and render it from a
      // same-origin blob URL, so the canvas is never CORS-tainted and failures show real HTTP status in Network
      if (resolvedImageId.startsWith('http://') || resolvedImageId.startsWith('https://')) {
        img.removeAttribute('crossorigin');
        this.http.get(resolvedImageId, { responseType: 'blob' }).subscribe({
          next: (blob: Blob) => {
            objectUrl = URL.createObjectURL(blob);
            img.src = objectUrl;
          },
          error: (httpErr) => {
            // console.error(`HTTP ${httpErr?.status} while fetching ${resolvedImageId}`, httpErr);
            reject(new Error(`Failed to load image: ${resolvedImageId}`));
          }
        });
      } else {
        img.src = resolvedImageId;
      }

      // Handle DICOM files
      if (!image.isApiImage && imageId.endsWith('.dcm')) {
        cornerstone.loadAndCacheImage(imageId)
          .then(dicomImage => {
            if (image.seriesDescription) {
              dicomImage.seriesDescription = image.seriesDescription;
            }
            resolve(dicomImage);
          })
          .catch(err => {
            // console.error('Failed to load DICOM image:', imageId, err);
            reject(err);
          });
      }
    });
  };
 
  // Load all images
  const promises = images.map(img => loadImage(img));
  Promise.all(promises)
    .then(loadedImages => {
      this.loadedImages = loadedImages;
      this.loadingImages = false;
      if (loadedImages.length > 0) {
        // this.displayImage(0); // Display first image
      }
    })
    .catch(err => {
      // console.error('Error loading study images:', err);
      this.loadingImages = false;
    });
 
  Promise.all(images.map(img => loadImage(img)))
    .then(loadedImages => {
      this.loadedImages = loadedImages;
      this.totalImages = loadedImages.length;
      this.loadingImages = false;
      this.currentImageIndex = 0;
 
      // Create series for the loaded images
      this.seriesList = loadedImages.map((image, index) => ({
        studyID: image.data?.string('x0020000d') || `image-${index}`,
        seriesID: image.data?.string('x0020000e') || `image-${index}`,
        seriesNumber: image.data?.intString('x00200011') || index,
        studyDescription: image.data?.string('x00081030') || 'Image',
        seriesDescription: image.seriesDescription || `Image ${index + 1}`,
        imageCount: 1,
        imageList: [image]
      }));
 
      // Display first image automatically
      if (this.seriesList.length > 0) {
        this.showSeries(0);
      }
    })
    .catch(error => {
      // console.error('Error loading images:', error);
      this.loadingImages = false;
      this.errorMessage = 'Failed to load some images.';
    });
}

//old method
// public loadStudyImages(images: any[]) {
//   // Reset viewer state

//   this.selectedImage = null;
//   this.element = this.viewPort.element;
//   this.clearMetadata();

//   // Store images with their base64 data for metadata fetching
//   this.imagesWithMetadata = images.map(img => ({
//     imageId: img.imageId,
//     base64: img.base64 || '',
//     fileName: img.fileName || img.seriesDescription || 'unknown'
//   })).filter(img => img.base64); // Only keep images that have base64 data
  
//   // Extract image IDs safely
//   this.imageIdList = images.map(img => {
//     if (img.isApiImage) {
//       return img.dataUrl || img.imageId || '';
//     }
//     return img.imageId || '';
//   }).filter(id => id !== '');

  
//   this.viewPort.resetViewer();
//   this.viewPort.resetImageCache();
//   this.seriesList = [];
//   this.currentSeriesIndex = 0;
//   this.loadedImages = [];
//   this.loadingImages = true;
//   this.targetImageCount = images.length;

//   const loadImage = (image: any): Promise<any> => {
//     return new Promise((resolve, reject) => {
//       // Handle API images (blob/data URL)
//       if (image.isApiImage) {
//         if (image.blob) {
//           this.convertBlobToImageData(image.blob, image.seriesDescription)
//             .then(imageData => resolve(imageData))
//             .catch(err => reject(err));
//         } else if (image.dataUrl) {
//           this.convertDataUrlToImageData(image.dataUrl, image.seriesDescription)
//             .then(imageData => resolve(imageData))
//             .catch(err => reject(err));
//         } else {
//           reject(new Error('API image has no blob or data URL'));
//         }
//         return;
//       }
      
//       // Handle regular images
//       const imageId = image.imageId || '';
//       const ext = imageId.split('.').pop()?.toLowerCase();
      
//       // Handle regular images (JPG/PNG)
//       if (!imageId.startsWith('wadouri:') && ext && ['png', 'jpg', 'jpeg'].includes(ext)) {
//         const img = new Image();
//         img.crossOrigin = 'Anonymous';
//         img.onload = () => {
//           const imageData = {
//             imageId: imageId,
//             minPixelValue: 0,
//             maxPixelValue: 255,
//             slope: 1,
//             intercept: 0,
//             windowCenter: 128,
//             windowWidth: 256,
//             getPixelData: () => {
//               const canvas = document.createElement('canvas');
//               canvas.width = img.width;
//               canvas.height = img.height;
//               const ctx = canvas.getContext('2d');
//               if (ctx) {
//                 ctx.drawImage(img, 0, 0);
//                 return ctx.getImageData(0, 0, img.width, img.height).data;
//               }
//               return new Uint8Array(0);
//             },
//             getImage: () => img,
//             rows: img.height,
//             columns: img.width,
//             height: img.height,
//             width: img.width,
//             color: true,
//             rgba: true,
//             sizeInBytes: img.width * img.height * 4,
//             rowPixelSpacing: 1,
//             columnPixelSpacing: 1,
//             seriesDescription: image.seriesDescription
//           };
//           resolve(imageData);
//         };
//         img.onerror = () => reject(new Error(`Failed to load image: ${imageId}`));
//         img.src = imageId;
//       } 
//       // Handle DICOM files
//       else {
//         cornerstone.loadAndCacheImage(imageId)
//           .then(dicomImage => {
//             if (image.seriesDescription) {
//               dicomImage.seriesDescription = image.seriesDescription;
//             }
//             resolve(dicomImage);
//           })
//           .catch(err => {
//             console.error('Failed to load DICOM image:', imageId, err);
//             reject(err);
//           });
//       }
//     });
//   };

//   Promise.all(images.map(img => loadImage(img)))
//     .then(loadedImages => {
//       this.loadedImages = loadedImages;
//       this.totalImages = loadedImages.length;
//       this.loadingImages = false;
//       this.currentImageIndex = 0;

//       // Create series for the loaded images
//       this.seriesList = loadedImages.map((image, index) => ({
//         studyID: image.data?.string('x0020000d') || `image-${index}`,
//         seriesID: image.data?.string('x0020000e') || `image-${index}`,
//         seriesNumber: image.data?.intString('x00200011') || index,
//         studyDescription: image.data?.string('x00081030') || 'Image',
//         seriesDescription: image.seriesDescription || `Image ${index + 1}`,
//         imageCount: 1,
//         imageList: [image]
//       }));

//       // Display first image automatically
//       if (this.seriesList.length > 0) {
//         this.showSeries(0);
//       }
//     })
//     .catch(error => {
//       console.error('Error loading images:', error);
//       this.loadingImages = false;
//       this.errorMessage = 'Failed to load some images.';
//     });
// }

// Helper method to convert blob to image data
private convertBlobToImageData(blob: Blob, description: string): Promise<any> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      const img = new Image();
      img.onload = () => {
        const imageData = {
          imageId: URL.createObjectURL(blob),
          minPixelValue: 0,
          maxPixelValue: 255,
          slope: 1,
          intercept: 0,
          windowCenter: 128,
          windowWidth: 256,
          getPixelData: () => {
            const canvas = document.createElement('canvas');
            canvas.width = img.width;
            canvas.height = img.height;
            const ctx = canvas.getContext('2d');
            if (ctx) {
              ctx.drawImage(img, 0, 0);
              return ctx.getImageData(0, 0, img.width, img.height).data;
            }
            return new Uint8Array(0);
          },
          getImage: () => img,
          rows: img.height,
          columns: img.width,
          height: img.height,
          width: img.width,
          color: true,
          rgba: true,
          sizeInBytes: img.width * img.height * 4,
          rowPixelSpacing: 1,
          columnPixelSpacing: 1,
          seriesDescription: description,
          isApiImage: true
        };
        resolve(imageData);
      };
      img.onerror = () => reject(new Error('Failed to load image from blob'));
      img.src = reader.result as string;
    };
    reader.onerror = () => reject(new Error('Failed to read blob'));
    reader.readAsDataURL(blob);
  });
}

// Helper method to convert data URL to image data
private convertDataUrlToImageData(dataUrl: string, description: string): Promise<any> {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => {
      const imageData = {
        imageId: dataUrl,
        minPixelValue: 0,
        maxPixelValue: 255,
        slope: 1,
        intercept: 0,
        windowCenter: 128,
        windowWidth: 256,
        getPixelData: () => {
          const canvas = document.createElement('canvas');
          canvas.width = img.width;
          canvas.height = img.height;
          const ctx = canvas.getContext('2d');
          if (ctx) {
            ctx.drawImage(img, 0, 0);
            return ctx.getImageData(0, 0, img.width, img.height).data;
          }
          return new Uint8Array(0);
        },
        getImage: () => img,
        rows: img.height,
        columns: img.width,
        height: img.height,
        width: img.width,
        color: true,
        rgba: true,
        sizeInBytes: img.width * img.height * 4,
        rowPixelSpacing: 1,
        columnPixelSpacing: 1,
        seriesDescription: description,
        isApiImage: true
      };
      resolve(imageData);
    };
    img.onerror = () => reject(new Error('Failed to load image from data URL'));
    img.src = dataUrl;
  });
}

public addAllImagesForCrosshairs(images: any[]) {
  if (!this.element || images.length < 2) return;

  // Create stack data
  const stack = {
    currentImageIdIndex: 0,
    imageIds: images.map(img => img.imageId),
    frameRate: 15
  };

  // Add stack state to Cornerstone
  cornerstoneTools.addStackStateManager(this.element, ['stack']);
  cornerstoneTools.addToolState(this.element, 'stack', stack);

  // Enable stack tools
  cornerstoneTools.setToolEnabledForElement(this.element, 'StackScroll');
  cornerstoneTools.setToolEnabledForElement(this.element, 'StackScrollMouseWheel');
}


public toggleCompareSelection(index: number, event: MouseEvent) {
  if (!this.isCompareMode) return;
  
  event.preventDefault();
  
  // Right click updates right side in comparison mode
  this.compareRightIndex = index;
  this.compareRightImage = this.loadedImages[index];
}

public toggleCompareMode() {
  // Require at least 2 images for comparison
  if (this.loadedImages.length < 2) {
    this.errorMessage = 'Comparison requires at least 2 images';
    return;
  }
  
  this.isCompareMode = !this.isCompareMode;
  
  if (this.isCompareMode) {
    // Set current image as left side
    this.compareLeftIndex = this.currentImageIndex;
    this.compareLeftImage = this.loadedImages[this.compareLeftIndex];
    
    // Try to select the next image for right side
    if (this.currentImageIndex < this.totalImages - 1) {
      this.compareRightIndex = this.currentImageIndex + 1;
      this.compareRightImage = this.loadedImages[this.compareRightIndex];
    } else if (this.totalImages > 1) {
      // If current is last, use the first image for right side
      this.compareRightIndex = 0;
      this.compareRightImage = this.loadedImages[0];
    } else if (this.totalImages === 1) {
      // If only one image, use the same image on both sides
      this.compareRightIndex = this.currentImageIndex;
      this.compareRightImage = this.loadedImages[this.currentImageIndex];
    }
    
    // Deactivate all tools in comparison mode
    this.deactivateAllTools();
  } else {
    // Exit comparison mode
    this.compareLeftIndex = -1;
    this.compareRightIndex = -1;
    this.compareLeftImage = null;
    this.compareRightImage = null;
  }
}

// Update the selectImageByIndex method to handle comparison selection (left click updates left side)
public selectImageByIndex(index: number) {
  if (index >= 0 && index < this.loadedImages.length) {
    if (this.isCompareMode) {
      // In comparison mode, left click updates left side
      this.compareLeftIndex = index;
      this.compareLeftImage = this.loadedImages[index];
    } else {
      // Normal behavior
      this.currentImageIndex = index;
      
      // Update the viewport to show the selected image
      if (this.viewPort) {
        this.viewPort.currentIndex = index;
        this.viewPort.displayImage(this.loadedImages[index]);
      }
      
      this.displayCurrentImage();
    }
  }
}

// Check if image is selected for comparison
public isSelectedForComparison(index: number): boolean {
  return this.isCompareMode && 
         (index === this.compareLeftIndex || index === this.compareRightIndex);
}


// Swap comparison images
public swapComparison() {
  if (!this.isCompareMode) return;
  
  const tempIndex = this.compareLeftIndex;
  const tempImage = this.compareLeftImage;
  
  this.compareLeftIndex = this.compareRightIndex;
  this.compareLeftImage = this.compareRightImage;
  
  this.compareRightIndex = tempIndex;
  this.compareRightImage = tempImage;
}

// Exit comparison mode
public exitCompareMode() {
  this.isCompareMode = false;
  this.compareLeftIndex = -1;
  this.compareRightIndex = -1;
  this.compareLeftImage = null;
  this.compareRightImage = null;
}


public isToolActive(toolName: string): boolean {
  return !!this.activeTools[toolName];
}

public logRegisteredTools() {
  // console.log('Registered tools:', cornerstoneTools.getToolState(this.element));
}

public isToolAvailable(toolName: string): boolean {
  return cornerstoneTools.getToolForElement(this.element, toolName) !== undefined;
}

public resetViewer(): void {
  if (this.element) {
    cornerstone.reset(this.element);
  }
}

public resetImageCache(): void {
  this.loadedImages = [];
  this.totalImages = 0;
  if (this.viewPort) {
    this.viewPort.resetImageCache();
  }
}

}